export const TOOLTIP_COLUMN_AD_NETWORK_NAME = "ad_network";

export const TOOLTIP_COLUMN_AD_NETWORK_SHARE = "share";
